
import { Input } from '@angular/core';
import { NxiBalancesGridHeaderComponent } from '../supporting/nxi-balances-grid-header.component';
import { BalancesConstants } from '../../utils/balances-constants';
import { BalancesResponse, CurrencyDetail } from '../../model/index';
import { BalancesService } from '../../services/balances.services';
import { ClientSideRowModelModule, GetDataPath, GridOptions, Module } from '@ag-grid-community/all-modules';

export class CurrencyBalancesBaseGrid {

    @Input() set balancesResponse(balancesResponse: BalancesResponse) {
        if (balancesResponse) {
            this.createRowData(balancesResponse);
            this.createColumnDefs();
            this.initGrid();
        }
    }

    rowData: any = [];
    columnDefs: any[];
    gridOptions: GridOptions;
    getDataPath: GetDataPath;
    public modules: Module[] = [ClientSideRowModelModule];
    isBankCustodyAccount: boolean = false;
    baseCurrency: string = '';

    customHeaders: any;

    constructor(private balancesService: BalancesService) { }

    initGrid() {
        this.gridOptions = {
            columnDefs: this.columnDefs,
            suppressMovableColumns: true,
            overlayLoadingTemplate: '<div class="progress-spinner"></div>',
            domLayout: 'autoHeight',
            suppressContextMenu: true,
            onGridSizeChanged: () => {
                if (this.gridOptions.api) { this.gridOptions.api.sizeColumnsToFit(); }
            },
            onGridReady: ($event) => {
                this.gridOptions.api.sizeColumnsToFit();
            },
            defaultColDef: {
                headerComponentFramework: NxiBalancesGridHeaderComponent,
                headerComponentParams: this.customHeaders
            },
            headerHeight: 50,
            rowHeight: 50,
            getDataPath: this.getDataPathVal
        };
    }
    getDataPathVal(data){
        return data.parent !== undefined ? data.parent : null;
    }

    createRowData(br: BalancesResponse) {

        this.baseCurrency = this.balancesService.displayParams$.baseCurrency;
        this.isBankCustodyAccount = this.balancesService.displayParams$.isCustodian;

        // Pick the right list per based currency and push USD row to top.
        this.rowData = CurrencyBalancesBaseGrid.parseCurrencyBalanceGrid(br);
    } 


    static parseCurrencyBalanceGrid(br: BalancesResponse){
       
        let isBankCustodyAccount = !!br.response.entity.custodianCode && br.response.entity.custodianCode === BalancesConstants.BNY_CUSTODIAN_CODE;
        let baseCurrency  = !!br.response.entity.baseCurrency ? br.response.entity.baseCurrency : BalancesConstants.USD_CURRENCY;
        let usdTop: CurrencyDetail[] = this.pushUsdToTop(baseCurrency === BalancesConstants.USD_CURRENCY ?
            br.response.balances.balancesDetails.localCurrencyDetailList : br.response.balances.balancesDetails.usdeCurrencyDetailList);

        // For custodian, change value of 'CASH' to 'PRINCIPAL' for account type.
        let mappedCl: CurrencyDetail[] = isBankCustodyAccount ? this.mapAccountType(usdTop) : usdTop;

        // Flatout the list which then would be grouped by grid by acctType.
        let flatCdl: CurrencyDetail[] = [];
        for (let key in mappedCl) {
            if (mappedCl.hasOwnProperty(key)) {
                flatCdl = flatCdl.concat(mappedCl[key]);
            }
        }

        let pArray = flatCdl.filter(function (item) { return item.localCcy.indexOf('Net ') !== -1; });
        let addParentToChildren = flatCdl.filter(function (item) { return item.localCcy.indexOf('Net ') === -1; });
        // Add parent to each item for easy access to parent when grouping.
        for (let rowpArray of pArray) {
            rowpArray.parent = []
            rowpArray.parent.push(rowpArray.acctType+rowpArray.localCcy)
            for (let rowaddParentChild of addParentToChildren) {
                if (rowpArray.acctType === rowaddParentChild.acctType) {
                    rowaddParentChild.parent = []
                    rowaddParentChild.parent.push(rowpArray.parent[0])
                    rowaddParentChild.parent.push(rowaddParentChild.acctType + rowaddParentChild.localCcy);
                    rowaddParentChild.parentValues = rowpArray
                }
            }
        }
        addParentToChildren.sort((a, b) => a.acctType.localeCompare(b.acctType));
        return pArray.concat(addParentToChildren);
    }

  static  pushUsdToTop(currencyList: any[]) {
        if (currencyList && currencyList.length > 0) {
            currencyList.forEach((item: any, index: number, arr: any) => {
                let usd = item.filter((element: CurrencyDetail) => { return element.localCcy === 'USD'; });
                let nonUsd = item.filter((element: CurrencyDetail) => { return element.localCcy !== 'USD'; });
                return arr[index] = usd.concat(nonUsd);
            });
        }
        return currencyList;
    }

    static mapAccountType(currencyList: any[]) {
        if (currencyList && currencyList.length > 0) {
            currencyList.forEach((cArray: CurrencyDetail[]) => {
                cArray.forEach((item: CurrencyDetail) => {
                    item.acctType = item.balanceType;
                    if (item.acctType === 'CASH') {
                        item.acctType = 'PRINCIPAL';
                    }
                });
            });
        }
        return currencyList;
    }

    getLegend(key: string, show: boolean, className: string) {
        return this.balancesService.updateDisclaimer({
            'legendSymbol': '', 'legendByIndex': true, 'key': key,
            'show': show, 'className': className, 'showCounter': 0
        });
    }

    createColumnDefs() {
        return;
    }
}
